// src/domains/core/dashboard/components/widgets/health/OuraCorrectionFactorWidget.tsx

import { TrendingUp } from "lucide-react";
import { type FC } from "react";

import { useWidgetConfig } from "../../../hooks/useWidgetConfig";
import { WIDGET_IDS } from "../../../store/widgetRegistry";
import { CorrectionFactor } from "../../organisms/CorrectionFactor";
import { WidgetContainer } from "../base";

/**
 * OuraCorrectionFactorWidget - Zeigt den Oura Korrekturfaktor
 *
 * @returns {JSX.Element} Oura correction factor widget component
 *
 */
export const OuraCorrectionFactorWidget: FC = () => {
  const { config } = useWidgetConfig(WIDGET_IDS.OURA_CORRECTION_FACTOR);

  return (
    <WidgetContainer
      description="TDEE correction factor based on weight and intake"
      icon={<TrendingUp className="w-5 h-5" />}
      size={config?.size ?? "medium"}
      title="Oura Correction Factor"
      widgetId={WIDGET_IDS.OURA_CORRECTION_FACTOR}
    >
      <CorrectionFactor />
    </WidgetContainer>
  );
};
